import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Partition } from '@classes/simulation/partition';
import { SimulationFlagType } from '@enums/simulation-flag-type.enum';
import { SimulationYear } from '@classes/simulation/simulation-year';

@Component({
    selector: 'app-cursors-list',
    templateUrl: './cursors-list.component.html',
    styleUrls: ['./cursors-list.component.scss']
})
export class CursorsListComponent implements OnInit {
    @Input() partitions: Partition[];
    @Input() articleType: string;
    @Output() applyPercent = new EventEmitter<{operator: string, selectedPart: Partition}>();

    lastButtonIndex = 2;
    flagType = SimulationFlagType;
    listTitle: string;

    constructor( ) {}

    ngOnInit() {
        this.listTitle = this.partitions
            .find(p => p.partitionDetails.articleType === this.articleType && p.partitionDetails.level === 1)
            .partitionDetails.text.shortLabel;
    }

    // isYearsEdited(mainCursor: Partition): boolean {
    //     const mainNodes = mainCursor.partitionDetails.node.split('/').filter(v => v !== "");
    //     return this.partitions.some(partition => {
    //         const nodes = partition.partitionDetails.node.split('/').filter(v => v !== "");
    //         let checkYears = true;
    //         mainNodes.every((n, i) => {
    //             if (nodes[i] !== n) {
    //                 checkYears = false;
    //             }
    //             return nodes.length !== i + 1;
    //         });
    //         if (checkYears && partition.simulationValues.years.some(y => y.flag === SimulationFlagType.modified)) {
    //             return true;
    //         }
    //     });
    // }

    onApplyPercent(operator: string, selectedPart: Partition) {
        this.applyPercent.emit({operator: operator, selectedPart: selectedPart});
    }
}
